import React from 'react';
import { Timer, Zap, Sparkles, Award } from 'lucide-react';

export default function DwellLadderCard({ dwell = {} }) {
  const { dwell15s = 0, dwell60s = 0, dwell3m = 0, dwell10m = 0 } = dwell;
  const maxVal = Math.max(dwell15s, dwell60s, dwell3m, dwell10m, 1);

  const steps = [
    {
      label: '15s Non-Bounce',
      sub: 'Passed glance filter',
      count: dwell15s,
      icon: Zap,
      color: 'bg-emerald-500',
    },
    {
      label: '60s Active Dwell',
      sub: 'Engaged consideration',
      count: dwell60s,
      icon: Timer,
      color: 'bg-blue-500',
    },
    {
      label: '3m Deep Focus',
      sub: 'Active creation / study',
      count: dwell3m,
      icon: Sparkles,
      color: 'bg-amber-500',
    },
    {
      label: '10m+ Immersion',
      sub: 'Power session',
      count: dwell10m,
      icon: Award,
      color: 'bg-purple-500',
    },
  ];

  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-4 sm:p-5 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-sm font-semibold text-slate-900 dark:text-white flex items-center gap-1.5">
            <Timer className="w-4 h-4 text-emerald-500" />
            Attention & Dwell Ladder
          </h3>
          <p className="text-[11px] text-slate-500 dark:text-slate-400">
            Active in-viewport time (tab blur pauses timers)
          </p>
        </div>
      </div>

      <div className="space-y-3 mt-3">
        {steps.map((step, idx) => {
          const pct = Math.round((step.count / maxVal) * 100);
          const Icon = step.icon;
          return (
            <div key={idx} className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <div className="flex items-center gap-1.5 min-w-0">
                  <Icon className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
                  <span className="font-medium text-slate-800 dark:text-slate-200 truncate">
                    {step.label}
                  </span>
                  <span className="text-[10px] text-slate-400 truncate hidden sm:inline">
                    · {step.sub}
                  </span>
                </div>
                <span className="font-mono font-bold text-slate-900 dark:text-white tabular-nums">
                  {step.count.toLocaleString()}
                </span>
              </div>
              <div className="w-full h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                <div
                  className={`h-full ${step.color} rounded-full transition-all duration-500`}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
